import { Component, EventEmitter, Input, Output } from '@angular/core'
import { Event } from '../../domain/Event'
import { environment } from '../../../environments/environment'
import { bookingPaymentTerminologyForVenueId } from '../../domain/BookingPaymentTerminology'
import { richTextPlainText, truncateRichTextHtml } from '../../utilities/rich-text'

@Component({
    selector: 'app-event-card',
    templateUrl: './event-card.component.html',
})
export class EventCardComponent {

    @Input() event!: Event
    @Input() currencyCode!: string
    @Input() canSelect!: boolean
    @Input() venueId?: string
    @Output() eventSelected = new EventEmitter<void>()
    showMore: boolean = false
    characterLimit: number = 140
    protected readonly richTextPlainText = richTextPlainText
    protected readonly truncateRichTextHtml = truncateRichTextHtml

    selectEvent() {
        this.eventSelected.emit()
    }

    get paymentTerminology() {
        return bookingPaymentTerminologyForVenueId(this.venueId)
    }

    protected readonly environment = environment
}
